module.exports = __webpack_public_path__ + "static/media/specialquiz-wordmark.e23a64d8.svg";